// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
    `,
};

productImageStyles.cutLengthBadgeOverlay = {
    css: css`
        position: absolute;
        bottom: 8px;
        left: 8px;
    `,
};

productImageStyles.cutLengthBadge = {
    css: css`
        margin-top: 8px;
    `,
};
